import { VAvatar } from 'vuetify/lib/components/VAvatar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ecs-avatar",class:{ ringing: _vm.hasIsRingingClass },style:(_vm.CSS_VARS)},[_c(VAvatar,{attrs:{"size":_vm.size,"color":_vm.color}},[(_vm.avatar)?_c('img',{staticClass:"ecs-avatar-image",attrs:{"src":_vm.avatar,"alt":"Avatar"}}):_c('span',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.initials)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }